import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import StatusActive from "../../../components/constants/StatusActive";
import axios from "axios";
import Layout from "../../../components/common/Layout";
import Alerts from "../../layout/Alerts";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import checkTime from "../../../components/constants/CheckTime"
import { addAuditLog } from "../../../components/AuditLog"

const nameColumns = [
  {
    cell: (row) => (
      <div>
        <Link to={'/names/view/'+row.NamesId} target="_blank" >
          <button className="btn btn-sm btn-primary"><i className="fa fa-eye"></i> View</button>
        </Link>
      </div>
    ),
    ignoreRowClick: false,
    allowOverflow: true,
    button: true,
    show: 1
  },
  {
    name: "Name",
    selector: "NamesName",
    sortable: true,
    wrap: true
  },
  {
    name: "Code",
    selector: "NamesCode",
    sortable: true,
    wrap: true
  },
  {
    name: "Initial",
    selector: "Initial",
    sortable: true,
    wrap: true
  },
  {
    name: "TaxID",
    selector: "TaxID",
    sortable: true,
    wrap: true
  },
  {
    name: "Postal Address",
    selector: "PostalAddress",
    sortable: true,
    //width: "350px",
    wrap: true
  },
  {
    name: "Telephone",
    selector: "Telephone",
    sortable: true,
    wrap: true
  },
  {
    name: "Fax",
    selector: "Fax",
    sortable: true,
    wrap: true
  },
  {
    name: "Electronic Mail",
    selector: "ElectronicMail",
    sortable: true,
    //width: "200px",
    wrap: true
  },
  {
    name: "Status",
    selector: "StatusActive",
    width: "100px",
    sortable: true,
    cell: row => (
      <div>
        {StatusActive.InActive === row.StatusActive && (
          <h6>
            <span className="badge badge-danger text-left">InActive</span>
          </h6>
        )}
        {StatusActive.Active === row.StatusActive && (
          <h6>
            <span className="badge badge-success text-left">Active</span>
          </h6>
        )}
      </div>
    )
  },
  {
    name: "LastUpdateBy",
    selector: "LastUpdateBy",
    sortable: true,
    //width: "200px",
    wrap: true
  },
  {
    name: "LastUpdateDateTime",
    selector: "LastUpdateDateTime",
    sortable: true,
    wrap: true
  },
  {
    name: "CreateBy",
    selector: "CreateBy",
    sortable: true,
    wrap: true
  },
  {
    name: "CreateDateTime",
    selector: "CreateDateTime",
    sortable: true,
    wrap: true
  }
];

const Name = props => {
  const userId =
  JSON.parse(localStorage.getItem("user")) === null
    ? null
    : JSON.parse(localStorage.getItem("user"))[0].Id;

  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 5)[0];

  const exportExcel = () => {
    //add Audit Log
    addAuditLog({ menu: "Names" , event: "Export Names", createBy: userId });

    const result = [];
    result.push(nameColumns.filter( c => columnsCheckFormData[c.selector]).map( x => x.name));

    (nameData).forEach(item => {
      let row = [];
      (Object.keys(columnsCheckFormData).filter(k => columnsCheckFormData[k])).forEach(key => {
        if(key === 'Image'){
          row.push(item['FilePath']);
        } else if(key === 'StatusActive'){
          row.push(item[key] ? 'Active' : 'InActive');
        } else {
          row.push(item[key]);
        }
      });
      result.push(row);
    });

    const cols = nameColumns.filter(c => columnsCheckFormData[c.selector]).map(x => x.name);
    const queryString = JSON.stringify(defaultSearchData);

    console.log(JSON.stringify(cols));
    console.log(JSON.stringify(defaultSearchData));

    //console.log(result); ${encodedJsonString}
    axios.get(process.env.REACT_APP_API_URL + "/api/exportexcelnames/", {
      responseType: 'blob',
      params: {col : `${JSON.stringify(cols)}`, searchFormData : `${queryString}` }
     }).then(response => {
        let link = document.createElement('a');
        let day = new Date();
     
        link.href = window.URL.createObjectURL(new Blob([response.data], 
          {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));;
        link.download = day.toISOString().slice(0,10) + "-Name_export.xlsx";
        link.click();
     }).catch(error => {
        console.log(error)
     })
  }
  const [isHidden, setIsHidden] = useState({
    names : 0,
    address : 1,
    case: 1
  })
  const [nameData, setnameData] = useState([]);
  const [showManageColumns, setShowManageColumns] = useState(false);
  const [listColumnsShow, setListColumnsShow] = useState([]);
  const [columnsCheckFormData, setcolumnsCheckFormdata] = useState({
    NamesName: 1,
    NamesCode: 1,
    Initial: 0,
    TaxID: 0,
    PostalAddress: 1,
    Telephone: 1,
    Fax: 0,
    ElectronicMail: 1,
    StatusActive: 1,
    LastUpdateBy: 1,
    LastUpdateDateTime: 1,
    CreateBy: 0,
    CreateDateTime: 0
  });
  const selectDefaultDdl = [
    { value: 0, label: "Start with"},
    { value: 1, label: "End with"},
    { value: 2, label: "Contain"},
    { value: 3, label: "Does not contain"},
    { value: 4, label: "Equal to"},
    { value: 5, label: "Does not equal to"}
  ];
  const [countryDdl, setCountryDdl] = useState([{ value: 0, label: "Select All" }]);
  const [nameTypeDdl, setNameTypeDdl] = useState([{ value: 0, label: "Select All" }]);
  // set default search
  const defaultSearchData = {
    nameTS: 0, // TS = Type Search
    nameText: '',
    nameCodeTS: 0,
    nameCodeText: '',
    initialTS: 0,
    initialText: '',
    addressTS: 0,
    addressText: '',
    filesInTS: 0,
    badDebtorTS: 0,
    badDebtorText: '',
    nameTypeTs: 0,
    noOfCasesText: 0
  };
  const [searchFormData, setSearchFormData] = useState(defaultSearchData);

  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime(); });
    submitsearch();
    axios.get(process.env.REACT_APP_API_URL + "/api/country/ddl").then(res => {
      setCountryDdl([{ value: 0, label: "Select All" }, ...res.data]);
    });
    axios.get(process.env.REACT_APP_API_URL + "/api/casenametype/ddl").then(res => {
      setNameTypeDdl([...nameTypeDdl, ...res.data]);
      });
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    setListColumnsShow(Object.keys(columnsCheckFormData).reduce((ret, curr) => 
    columnsCheckFormData[curr] ? [...ret, curr] : ret
    , []));
  },[columnsCheckFormData])
  useEffect(() => {
    if ((searchFormData.nameTypeTs !== 0 || searchFormData.filesInTS !== 0) 
      && searchFormData.noOfCasesText === 0){
      setSearchFormData({ ...searchFormData, noOfCasesText: 1 })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[searchFormData.nameTypeTs, searchFormData.filesInTS])


  
  const submitsearch = () => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/names", {
        params: searchFormData
      })
      .then(res => {
        setnameData(res.data);
      });
  };
  const onChangeSelectSearch = (e, name) => {
    setSearchFormData({ ...searchFormData, [name]: e.value})
  }
  const onChangeTextSearch = (e) => {
    setSearchFormData({ ...searchFormData, [e.target.name]: e.target.value })
  }
  const onChangeCheckColumns = (e) => {
    setcolumnsCheckFormdata({ 
      ...columnsCheckFormData, [e.target.name] : !columnsCheckFormData[e.target.name]
    })
  }
  const checkInputManageColumn = (name) => 
    (<div key={name} className="col-sm-12">
        <input 
          type="checkbox" 
          className="checkboxCustom1"
          name={name} 
          id={name}
          defaultChecked={columnsCheckFormData[name]} 
          onChange={onChangeCheckColumns} />
          <label htmlFor={name}> {nameColumns.filter( c => c.selector === name)[0].name}</label>
      </div>)

  return (
    <Layout activeLinkTo="/names" menuId="5">
      <div className="container-fluid" style={{ minHeight: 500 }}>
      <Alerts />
        <div className="card border-secondary"> {/* Name */}
          <h5 
            className="card-header text-white" 
            style={{backgroundColor:"rgb(80, 79, 125)", cursor:"pointer"}}
            onClick={ () => setIsHidden({ ...isHidden, name: !isHidden.name})}>
            <i className={"fa fa-" + (isHidden.name ? "plus" : "minus") + "-square-o"} />  Name
          </h5>
          <div className="card-body" hidden={isHidden.name}>
            <div className="row">
              <div className="col-lg-6">
                <label className="title control-label">
                  Name Code
                </label>
                <div className="input-group">
                  <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                  <Select 
                    onChange={ e => onChangeSelectSearch(e, "nameCodeTS")}
                    value={selectDefaultDdl[searchFormData.nameCodeTS]}
                    options={selectDefaultDdl}
                  />
                  </div>
                  <input
                    type="search"
                    className="form-control col-lg-8"
                    name="nameCodeText"
                    value={searchFormData.nameCodeText}
                    onChange={onChangeTextSearch}
                    onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <label className="title control-label">
                  Name
                </label>
                <div className="input-group">
                  <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                  <Select 
                    onChange={ e => onChangeSelectSearch(e, "nameTS")}
                    value={selectDefaultDdl[searchFormData.nameTS]}
                    options={selectDefaultDdl}
                  />
                  </div>
                  <input
                    type="search"
                    className="form-control col-lg-8"
                    name="nameText"
                    value={searchFormData.nameText}
                    onChange={onChangeTextSearch}
                    onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <label className="title control-label">
                  Initial
                </label>
                <div className="input-group">
                  <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                  <Select 
                    onChange={ e => onChangeSelectSearch(e, "initialTS")}
                    value={selectDefaultDdl[searchFormData.initialTS]}
                    options={selectDefaultDdl}
                  />
                  </div>
                  <input
                    type="search"
                    className="form-control col-lg-8"
                    name="initialText"
                    value={searchFormData.initialText}
                    onChange={onChangeTextSearch}
                    onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p>&nbsp;</p>
        <div className="card border-secondary"> {/* Address */}
          <h5 
            className="card-header text-white" 
            style={{backgroundColor:"rgb(125, 88, 68)", cursor:"pointer"}}
            onClick={ () => setIsHidden({ ...isHidden, address: !isHidden.address})}>
            <i className={"fa fa-" + (isHidden.address ? "plus" : "minus") + "-square-o"} />  Address
          </h5>
          <div className="card-body" hidden={isHidden.address}>
            <div className="row">
              <div className="col-lg-6">
                <label className="title control-label">
                  Text
                </label>
                <div className="input-group">
                  <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                  <Select 
                    onChange={ e => onChangeSelectSearch(e, "addressTS")}
                    value={selectDefaultDdl[searchFormData.addressTS]}
                    options={selectDefaultDdl}
                  />
                  </div>
                  <input
                    type="search"
                    className="form-control col-lg-8"
                    name="addressText"
                    value={searchFormData.addressText}
                    onChange={onChangeTextSearch}
                    onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p>&nbsp;</p>
        <div className="card border-secondary"> {/* Case Details */}
          <h5 
            className="card-header text-white" 
            style={{backgroundColor:"rgb(218, 145, 163)", cursor:"pointer"}}
            onClick={ () => setIsHidden({ ...isHidden, case: !isHidden.case})}>
            <i className={"fa fa-" + (isHidden.case ? "plus" : "minus") + "-square-o"} />  Case Details
          </h5>
          <div className="card-body" hidden={isHidden.case}>
            <div className="row">
              <div className="col-lg-4">
                <label className="title control-label">
                  Name Type
                </label>
                <Select
                  onChange={ e => onChangeSelectSearch(e, "nameTypeTs")}
                  value={nameTypeDdl.filter(x => x.value === searchFormData.nameTypeTs)}
                  options={nameTypeDdl}
                />
              </div>
              <div className="col-lg-4">
                <label className="title control-label">
                  Files In
                </label>
                <Select
                  onChange={ e => onChangeSelectSearch(e, "filesInTS")}
                  value={countryDdl.filter(x => x.value === searchFormData.filesInTS)}
                  options={countryDdl}
                />
              </div>
              <div className="col-lg-4">
                <label className="title control-label">
                  No of cases (Greater Than or Equal To)
                </label>
                <input
                  type="number"
                  min={(searchFormData.nameTypeTs === 0 && searchFormData.filesInTS === 0)? 0 : 1}
                  className="form-control"
                  name="noOfCasesText"
                  value={searchFormData.noOfCasesText}
                  onChange={onChangeTextSearch}
                  onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6" 
                style={{backgroundColor: "rgb(231, 231, 231)", color: "darkgrey", radius: "10px"}} //lock this time
              >
                <label className="title control-label">
                  Bad Debtor
                </label>
                <div className="input-group">
                  <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                  <Select 
                    onChange={ e => onChangeSelectSearch(e, "badDebtorTS")}
                    value={selectDefaultDdl[searchFormData.badDebtorTS]}
                    options={selectDefaultDdl}
                    isDisabled //lock this time
                  />
                  </div>
                  <input
                    type="search"
                    className="form-control col-lg-8"
                    name="badDebtorText"
                    value={searchFormData.badDebtorText}
                    onChange={onChangeTextSearch}
                    disabled //lock this time
                    onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        { 
          // ----------------------------------button---------------------------------------
        }
        <div className="card-body text-right">
        <button
          type="button"
          className="btn btn-secondary mr-2"
          onClick={() => setSearchFormData(defaultSearchData)}
        >
          <i className="fa fa-refresh" /> Clear
        </button>
          <button
              type="button"
              className="btn btn-primary"
              onClick={submitsearch}
            >
            <i className="fa fa-search" /> Search
          </button>
        </div>
        
        <hr style={{borderTop:"1px solid rgb(173, 173, 173)"}}/>
        {
          // ----------------------------------Result---------------------------------------
        }
        <div className="card border-secondary">
          <h5 className="card-header text-white bg-primary">Data</h5>
          <div className="card-body">
            <div className="row">
              <div className="table-responsive">
                <Link to="/names/add" hidden={!pagePermission.IsCreate}>
                  <button type="button" className="btn btn-success">
                    <FontAwesomeIcon icon={faPlus} /> Add
                  </button>
                </Link>
                  <button type="button" className="btn btn-primary ml-2" onClick={() => {setShowManageColumns(true)}}>
                    <i className="fa fa-cog"></i> Manage Columns
                  </button>
                  <button type="button" className="btn btn-primary mr-2" 
                    style={{position:"absolute", right:0}} 
                    onClick={() => exportExcel()} >
                    <i className="fa fa-external-link"></i> Export file
                  </button>
                <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                  <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
                </a>
                <DataTable
                  noHeader={true}
                  pagination={true}
                  paginationPerPage={50}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  columns={nameColumns.filter(columns => listColumnsShow.includes(columns.selector)||columns.show === 1 )}
                  data={nameData}
                />
                <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                  <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Manage Columns*/}
      <Modal
        size="sm"
        dialogClassName="columnsManageCustom"
        show={showManageColumns}
        onHide={() => {
          setShowManageColumns(false);
        }}
        centered
      >
        <Modal.Header closeButton className="replaceCloseBtn">
          <Modal.Title><i className="fa fa-columns" /> Manage Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {Object.keys(columnsCheckFormData).map( (e) => checkInputManageColumn(e))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal Manage columns*/}
    </Layout>
  );
};

export default Name;
